import {DEFAULT_LOCALE} from '../../config';
import {AVAILABLE_LOCALES} from 'services/locale/constants';


const LOCALE_KEY = 'alva:locale';

export const getLocaleState = () => {

    if (!window.localStorage) {
        return getDefaultState();
    }

    // Parse data from local storage
    let savedState;

    try {
        savedState = JSON.parse(localStorage.getItem(LOCALE_KEY));
    }
    catch (e) {
        return getDefaultState();
    }

    // Make sure that the returned object have the same format as 'initialUi'
    // This returns a new object where initialUi is overridden with settings in saved state
    return Object.assign({}, getDefaultState(), savedState);
};

function getDefaultState() {
    const languages = navigator.languages, userLanguage = navigator.userLanguage, language = navigator.language, browserLanguage = navigator.browserLanguage;
    return {
        locale: getUserPreferredLanguage(languages, userLanguage, language, browserLanguage)
    };
}

export function getUserPreferredLanguage(languages, userLanguage, language, browserLanguage) {

    if (languages && languages.length) {
        const matchedLocale = languages.find(locale => {
            return matchLocaleAgainstAvailableLocales(locale);
        });
        if (matchedLocale) {
            return matchedLocale.slice(0, AVAILABLE_LOCALES[0].length);
        }
    }

    const locale = userLanguage || language || browserLanguage;

    if (locale) {
        const matchedLocale = matchLocaleAgainstAvailableLocales(locale);

        if (matchedLocale) {
            return matchedLocale;
        }
    }

    return DEFAULT_LOCALE;
}

function matchLocaleAgainstAvailableLocales(locale) {
    return AVAILABLE_LOCALES.find(availableLocale => {
        if (locale.startsWith(availableLocale)) {
            return availableLocale;
        }
    });
}

export const saveLocaleState = (data) => {
    if (!window.localStorage) {
        return;
    }
    window.localStorage.setItem(LOCALE_KEY, JSON.stringify(data));
};
